import messaging from "@react-native-firebase/messaging";
import { requestNotifications } from "react-native-permissions";
import { isAndroid } from "./deviceDetectors";

const requestNotificationPermission = async () => {
  if (isAndroid) {
    return await requestNotifications(["alert"]);
  }
  return await messaging().requestPermission();
};

export default requestNotificationPermission;
